import { render, staticRenderFns } from "./CmgSustainabilityStatsPage.vue?vue&type=template&id=bfead196&scoped=true&lang=pug&"
import script from "./cmg-sustainability-stats-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-sustainability-stats-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgSustainabilityStatsPage.vue?vue&type=style&index=0&id=bfead196&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfead196",
  null
  
)

export default component.exports